import $ from 'jquery'

let $main

export function initialise() {
  $main = $('#tessitura-content')

  if (!$main.length) {
    return
  }

  injectSections()
  hideTicketTypeForSomeCampaigns()
}

function injectSections() {
  const $target = $('[data-tessitura-sections]')
  const script = $target.attr('data-tessitura-sections')
  const url = script + '?url=' + window.encodeURIComponent(window.location.href)
  $target.load(url)
}

// thanks Tessitura for being awesome
function hideTicketTypeForSomeCampaigns() {
  const paths = ['/support/take-a-seat', '/support/dressing-stations']
  if (paths.indexOf(window.location.pathname) >= 0) {
    $('head').append($('<style>.tn-syos-seat-info__price-type-heading { display: none; }</style>'))
  }
}
